import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
  NgZone,
  output,
} from '@angular/core';
import { HashMap } from '@ngneat/transloco';

@Component({
  selector: 'lib-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FileUploadComponent {
  id = input<string>();
  allowedFileTypes = input<string>();
  disabled = input<boolean>();
  error = input<boolean>();
  uploadedFiles = input<UploadedFile[]>();
  required = input<boolean>();
  maxNumberOfFiles = input<number>();
  maxFileSize = input<number>();
  maxNumberOfPages = input<number>();
  readonly = input<boolean>();
  changedFileIds = input<string[]>([]);

  @Input() isUpdatingAnswer: boolean;
  upload = output<File[]>();
  download = output<UploadedFile>();
  remove = output<UploadedFile>();
  fileWindow = output<boolean>();

  private fileSelected = false;

  UploadedFileStatus = UploadedFileStatus;

  constructor(private zone: NgZone) {}

  onFileDropped(event): void {
    this.upload.emit(event);
  }

  onFileSelected(event): void {
    this.fileSelected = true;
    this.upload.emit(event.target.files);
    event.target.value = '';
  }

  downloadFile(file: UploadedFile) {
    this.download.emit(file);
  }

  removeFile(file: UploadedFile) {
    this.remove.emit(file);
  }

  onWindowOpen() {
    this.fileWindow.emit(true);
    this.fileSelected = false;
    const zone = this.zone;
    const fileSelected = this.fileSelected;
    const fileWindow = this.fileWindow;
    window.addEventListener('focus', function focusEvent() {
      zone.runOutsideAngular(() => {
        setTimeout(() => {
          if (!fileSelected) {
            fileWindow.emit(false);
          }
        }, 200);
      });
      window.removeEventListener('focus', focusEvent);
    });
  }
}

export interface UploadedFile {
  uploadId: string;
  pdfFileId: string;
  fileId?: number;
  pdfFileName: string;
  originalFileName: string;
  status: UploadedFileStatus;
  validationMessageKey?: string;
  fileSize: number;
  pages: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validationMessageParams?: HashMap<any>;
}

export enum UploadedFileStatus {
  Uploaded,
  Loading,
  Success,
  ToManyPages,
  Error,
}
